import React from "react";
import { Box } from "@mui/material";
import IndexPump from "./IndexPump/IndexPump";
import PhotoNote from "./PhotoNote/PhotoNote";
import Cuve from "./Cuve/Cuve";
import Versement from "./Versement/Versement";
import Approv from "./Approv/Approv";
import RetraitProduit from "./RetraitProduit/RetraitProduit";
import RetraitArgent from "./RetRemArgent/RetRemArgent";
import Fermeture from "./Fermeture/Fermeture";
// import MyMatrixForm from "../../components/CardSection/MyMatrixForm"; // removed unused import

const Station = () => {
  return (
    <Box
      sx={{
        m: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 600 }}>
        <IndexPump />
        <PhotoNote />
        <Cuve />
        <Versement title="VERSEMENT" />
        <Approv />
        <RetraitProduit />
        <RetraitArgent />
        <Fermeture />
      </Box>
    </Box>
  );
};

export default Station;
